// extracted by mini-css-extract-plugin
export default {"container":"adminLessons_container__Ra+XX","title":"adminLessons_title__LTUhO","loader":"adminLessons_loader__lxqr2","count":"adminLessons_count__a+bxx"};